<template>
    <div>
        <public-menu></public-menu>
        <public-help-password></public-help-password>
        <bottom-nav></bottom-nav>
        <public-footer></public-footer>
    </div>
</template>

<script>
import Public_menu from "@/components/common/public-top"
import Public_help_password from "@/components/help/forgetpassword"
import Bottom_nav from "@/components/common/bottom-nav"
import Footer from "../../components/Footer.vue"
export default {
    components:{
        'public-menu': Public_menu,
        'public-help-password': Public_help_password,
        'bottom-nav': Bottom_nav,
        'public-footer': Footer
    }
}
</script>

<style scoped>
@import url('../../assets/css/style.css');

</style>


// WEBPACK FOOTER //
// src/views/help/forgetpassword.vue